import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { apiRequest } from '@/shared/api'
import { type SlotEntityKind, SlotSchema } from '../model/types'

export const slotKeys = {
  byEntity: (kind: SlotEntityKind, id: string) => ['slot', kind, id] as const,
}

// Слоты сущности — структура документарной части и пикер для create-document.
export function entitySlotsQueryOptions(kind: SlotEntityKind, id: string) {
  return queryOptions({
    queryKey: slotKeys.byEntity(kind, id),
    queryFn: async () => {
      const body = await apiRequest<{ items: unknown[] }>({
        method: 'GET',
        url: '/slots',
        query: { entity_kind: kind, entity_id: id },
      })
      return z.array(SlotSchema).parse(body.items)
    },
    staleTime: 60_000,
  })
}
